'use client';

import React from 'react';
import { ConTextAtom } from '@gandalf/babylon/atoms/text';
import { Link } from '@frodo/ui/tokens/link/Link';
import { CountdownDateTime } from '@frodo/models/types';
import { useCountdown } from '@frodo/lib/hooks/utility/useCountdown';

type CountdownProps = CountdownDateTime & {
  link?: string;
  className?: string;
  dataAttrs?: Record<string, string>;
};

const convertToISOString = (datetime: CountdownDateTime): string => {
  const { year, month, day, hour, minute } = datetime;
  const date = new Date(
    parseInt(year),
    parseInt(month) - 1,
    parseInt(day),
    parseInt(hour),
    parseInt(minute),
    0,
  );

  return date.toISOString();
};

export const Countdown = ({
  timezone,
  year,
  month,
  day,
  hour,
  minute,
  link,
  className,
  dataAttrs,
}: CountdownProps) => {
  const isoString = convertToISOString({
    timezone,
    year,
    month,
    day,
    hour,
    minute,
  });
  const timeLeft = useCountdown(new Date(isoString));

  const countdownText = `${timeLeft.days} : ${timeLeft.hours} : ${timeLeft.minutes} : ${timeLeft.seconds}`;

  if (link) {
    return (
      <Link
        ariaLabel={link}
        target="_blank"
        fontWeight="bold"
        color="text-neutral-1"
        responsiveFontSizes="small"
        href={link}
      >
        {countdownText}
      </Link>
    );
  }

  return (
    <ConTextAtom
      color="text-neutral-1"
      fontWeight="bold"
      fontSizes="small"
      cls={className}
      {...dataAttrs}
    >
      {countdownText}
    </ConTextAtom>
  );
};
